import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Title text-center mb-12"
}
const _hoisted_2 = {
  key: 1,
  class: "Title text-center mb-12"
}
const _hoisted_3 = {
  key: 2,
  class: "Title text-center mb-12"
}
const _hoisted_4 = {
  key: 3,
  class: "flex items-center justify-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "Button w-full max-w-[480px]",
  href: "https://g.page/r/CQ9VgxY1vLAyEBM/review",
  target: "_blank"
}, " Dodaj opinię na Google ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 5,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 8,
  class: "flex items-center justify-center mt-12"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
}
const _hoisted_13 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import { useField } from 'vee-validate';
import MessageField from './MessageField.vue';
import RatingField from './RatingField.vue';
import { computed } from 'vue';
import EmailField from './EmailField.vue';


export default {
  __name: 'FormBody',
  props: {
    isSubmitting: Boolean,
    status: String,
},
  setup(__props) {

const props = __props;



const { value } = useField('rating');
const { value: message } = useField('message');
const { value: email } = useField('email');

const showFields = computed(() => {
    return value.value && Number(value.value) < 5;
});

const isButtonEnabled = computed(() => {
    return message.value.length > 0 && email.value.length > 0;
});
const url = jsData.siteUrl;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.status != 'success' && _unref(value) !== 5)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, " Jak oceniasz wykonaną usługę w skali od 1 do 5? "))
      : _createCommentVNode("", true),
    (__props.status == 'success' && _unref(value) !== 5)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, " Dziękujemy za przesłanie opinii "))
      : _createCommentVNode("", true),
    (_unref(value) === 5)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_3, " Dziękujemy za pozytywną opinię! Będzie nam bardzo miło, jeśli zostawisz ją również na Google. "))
      : _createCommentVNode("", true),
    (_unref(value) === 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (__props.status !== 'success' && _unref(value) !== 5)
      ? (_openBlock(), _createBlock(RatingField, { key: 4 }))
      : _createCommentVNode("", true),
    (__props.status === 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("a", {
            href: _unref(url),
            class: "text-[17px] font-semibold leading-[22px] my-4 text-success text-center underline"
          }, " Powrót na stronę główną ", 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    (_unref(showFields) && __props.status !== 'success')
      ? (_openBlock(), _createBlock(EmailField, { key: 6 }))
      : _createCommentVNode("", true),
    (_unref(showFields) && __props.status !== 'success')
      ? (_openBlock(), _createBlock(MessageField, { key: 7 }))
      : _createCommentVNode("", true),
    (_unref(showFields) && __props.status !== 'success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "Button relative py-4 px-8 roundend-lg flex items-center justify-center max-w-[319px] w-full text-white",
            disabled: !_unref(isButtonEnabled)
          }, [
            (!__props.isSubmitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Wyślij opinię "))
              : _createCommentVNode("", true),
            (__props.isSubmitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  (__props.isSubmitting)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}